// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dv-options[data-v-abe5abec]{width:100%;height:auto;padding:.625rem;position:relative;box-sizing:border-box}.dv-options .graph-container[data-v-abe5abec]{width:99%;min-height:31.25rem}", ""]);
// Exports
module.exports = exports;
